// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7e06d3fb","963":"f1f21a1d"}[chunkId] + ".chunk.js";
};